export default "__VITE_ASSET__DcGQL187__"